import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	fetchPriorityGroupError: {
		id: 'servicedesk-queues-nav4.common.practice-queues.queue-groups.fetch-priority-group-error',
		defaultMessage: "We're unable to load data in the priority group, <button>try again.</button>",
		description: 'Error message when fail to fetch priority group data in sidebar',
	},
});
